import { connect } from 'react-redux';
import { RootState } from 'src/store';
import TraceRuler from './TraceRuler';

const mapStateToProps = (state: RootState) => ({
    enabled: state.pages.editor.canvas.isTraceRulerEnabled,
    mousePosition: state.pages.editor.canvas.mousePosition,
    color: state.pages.editor.canvas.traceRulerColor,
    spacing: state.pages.editor.canvas.traceRulerSpacing,
    scale: state.pages.editor.canvas.scale,
    offset: state.pages.editor.canvas.offset,
});

const TraceRulerContainer = connect(mapStateToProps)(TraceRuler);

export default TraceRulerContainer;
